import { useEffect, useRef } from 'react'

import { mapEventToFormData } from '@components/MatchEventEditor/utils'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'
import { useSelectedEventContext } from '@contexts/SelectedEventContext'

import { useEventFormOptions } from './useEventFormOptions'

export function useEventFormHydration() {
    const { selectedEvent } = useSelectedEventContext()
    const { resetForm, setIsAdditionalTimeSelected, setIsFormDisabled } = useMatchEditorFormContext()
    const options = useEventFormOptions()

    const hydratedEventIdRef = useRef<string | null>(null)

    useEffect(() => {
        const currentEventId = selectedEvent ? String(selectedEvent.id) : null

        // Already hydrated → do nothing
        if (hydratedEventIdRef.current === currentEventId) {
            return
        }

        // New Event
        if (!selectedEvent) {
            hydratedEventIdRef.current = null

            resetForm()

            setIsAdditionalTimeSelected(false)

            setIsFormDisabled(false)

            return
        }

        // Guard: options must exist; when event has team and player ids, that team's player options must be loaded
        const hasPlayerIds = Boolean(selectedEvent.player1_id || selectedEvent.player2_id)
        const teamPlayerOptions = selectedEvent.team_id ? options.players[selectedEvent.team_id] : undefined
        const hasTeamPlayerOptions = Array.isArray(teamPlayerOptions) && teamPlayerOptions.length > 0

        if (!options.periods.length || !options.teams.length || (hasPlayerIds && !hasTeamPlayerOptions)) {
            return
        }

        const { formData, isAdditionalTimeSelected } = mapEventToFormData(selectedEvent, options)
        setIsAdditionalTimeSelected(isAdditionalTimeSelected)

        setIsFormDisabled(!selectedEvent.isEditable)

        resetForm(formData)

        // Mark as hydrated after successful hydration
        hydratedEventIdRef.current = currentEventId
    }, [selectedEvent, options, resetForm, setIsAdditionalTimeSelected, setIsFormDisabled])
}
